import * as types from "./userTeamFavoritesTypes";
import * as userTeamImagesTypes from "state/entities/userTeamImages/userTeamImagesTypes";
import * as teamImagesTypes from "state/entities/teamImages/teamImagesTypes";
import * as teamLogosTypes from "state/entities/teamLogos/teamLogosTypes";
import * as userTeamAnimationsTypes from "state/entities/userTeamAnimations/userTeamAnimationsTypes";

import { merge } from "lib/lodash";

export const initState = {};

const userTeamFavoritesReducers = (state = initState, action) => {
  switch (action.type) {
    case types.USER_TEAM_FAVORITES_CREATE_REQUEST_SUCCESS: {
      const { entities = {} } = action.response;

      return merge({}, entities.userTeamFavorite, state);
    }

    case types.USER_TEAM_FAVORITES_REQUEST_SUCCESS: {
      const { entities = {} } = action.response;

      return merge({}, state, entities.userTeamFavorite);
    }

    case types.USER_TEAM_FAVORITES_REMOVE_REQUEST_SUCCESS: {
      const {
        extra: { mediaId }
      } = action;

      const newState = Object.assign({}, state);
      delete newState[mediaId];

      return newState;
    }

    case userTeamImagesTypes.USER_TEAM_IMAGE_DELETE_REQUEST:
    case userTeamAnimationsTypes.USER_TEAM_ANIMATION_DELETE_REQUEST: {
      const newState = Object.assign({}, state);
      delete newState[action.request.mediaId];
      return newState;
    }

    case teamImagesTypes.TEAM_DELETE_IMAGE_REQUEST:
    case teamLogosTypes.TEAM_DELETE_LOGO_REQUEST: {
      const newState = Object.assign({}, state);
      delete newState[action.extra.mediaId];
      return newState;
    }

    case userTeamImagesTypes.USER_TEAM_IMAGES_DELETE_REQUEST:
    case userTeamAnimationsTypes.USER_TEAM_VIDEOS_DELETE_REQUEST: {
      const newState = Object.assign({}, state);
      action.extra.mediaIds.forEach(mediaId => {
        delete newState[mediaId];
      });
      return newState;
    }

    default:
      return state;
  }
};

export default userTeamFavoritesReducers;
